module.exports = __webpack_public_path__ + "img/histograms.e208f589.png";